Vue.component('package-list', {
	template: `
	<div id="package_dynamic">
		<p class=" t:text-justify" v-html="firstIntro"></p>
		<div v-if="link" class="package_more_info" v-html="link"></div>
		<div class="filter_bar">
			<div class="top_bar" v-if="packageTabs.length>2 && onlyAllowedSelected">
				<div>
					<ul>
						<li v-for="tab in packageTabs" :class="{selected: tab.value == selectedFilter}">
							<button @click="updateFilter(tab.value)" v-text="tab.label"></button>
						</li>
					</ul>
				</div>
			</div>
			<div class="bottom_bar">
				<div class="flex items-center" v-if="destinationList.length>1">
					<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
						<path d="M10 20a10 10 0 1 1 0-20 10 10 0 0 1 0 20zm2-2.25a8 8 0 0 0 4-2.46V9a2 2 0 0 1-2-2V3.07a7.95 7.95 0 0 0-3-1V3a2 2 0 0 1-2 2v1a2 2 0 0 1-2 2v2h3a2 2 0 0 1 2 2v5.75zm-4 0V15a2 2 0 0 1-2-2v-1h-.5A1.5 1.5 0 0 1 4 10.5V8H2.25A8.01 8.01 0 0 0 8 17.75z"/>
					</svg>
					<span class="mx-1/4">Destination</span>
					<select v-model="selectedDestination" @change="updateDestination">
						<option value="all">All</option>
						<option v-for="destination in destinationList" :value="destination" v-text="titlecase(destination)"></option>
					</select>
				</div>

				<div class="flex items-center" v-if="allowLocaleSelection && localeList.length > 1">
					<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
						<path d="M0 0l6 4 8-4 6 4v16l-6-4-8 4-6-4V0zm7 6v11l6-3V3L7 6z"/>
					</svg>
					<span class="mx-1/4">Locale</span>
					<select v-model="selectedLocale" @change="updateLocale">
						<option value="all">All</option>
						<option v-for="locale in localeList" :value="locale.value" v-text="locale.name"></option>
					</select>
				</div>

				<div class="flex items-center">
					<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
						<path d="M10 20a10 10 0 1 1 0-20 10 10 0 0 1 0 20zm1-5h1a3 3 0 0 0 0-6H7.99a1 1 0 0 1 0-2H14V5h-3V3H9v2H8a3 3 0 1 0 0 6h4a1 1 0 1 1 0 2H6v2h3v2h2v-2z"/>
					</svg>
					<span class="mx-1/4">Price</span>
					<button class="px-1/4 py-1/8" @click="sortDirection == 'asc'? sortDirection = 'desc': sortDirection = 'asc'">
					<svg width="17px" height="17px" viewBox="0 0 17 17" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
						<g :transform="'rotate('+(sortDirection=='asc'?90:270)+' 8 8)'">
								<polygon points="16.32 7 11.5 0 6.5 0 10 5 0 5 0 9 10 9 6.5 14 11.5 14"></polygon>
						</g>
					</svg>
					</button>
				</div>

				<div class="flex items-center" v-if="groupSizeList.length > 1">
					<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
						<path d="M7 8a4 4 0 1 1 0-8 4 4 0 0 1 0 8zm0 1c2.15 0 4.2.4 6.1 1.09L12 16h-1.25L10 20H4l-.75-4H2L.9 10.09A17.93 17.93 0 0 1 7 9zm8.31.17c1.32.18 2.59.48 3.8.92L18 16h-1.25L16 20h-3.96l.37-2h1.25l1.65-8.83zM13 0a4 4 0 1 1-1.33 7.76 5.96 5.96 0 0 0 0-7.52C12.1.1 12.53 0 13 0z"/>
					</svg>
					<span class="mx-1/4">Group Size</span>
					<select v-model="selectedGroupSize" @change="updateGroupSize">
						<option value="all">All</option>
						<option v-for="value in groupSizeList" :value="value" v-text="value"></option>
					</select>
				</div>

			</div>
		</div>

		<div v-for="destination in filteredDestinations" class="locale_card">
			<h3 v-text="destination.name.replace(/-/g, ' ')"></h3>
			<div v-for="group in destination.locales">
				<h4 v-if="localeGroup" v-text="group.heading"></h4>
				<div class="wrappackages">
					<div v-for="package in group.packages" class="accommodation_card">
						<a v-if="package.link" :href="package.link">
							<img class="h-6 t:h-8 bg-gray-100 w-full object-cover border-0" :src="package.image_url!='/uploads/'?package.image_url:'/svg/sunset_tight.svg'" :alt="package.image_alt" :title="package.image_title" loading="lazy">
						</a>
						<div class="head">
							<h5 class="f8" v-html="package.name"></h5>
							<div class="rating mr-1/4 flex" v-if="parseFloat(package.rating) > 0" :aria-label="'Rated '+package.rating+' stars'">
								<span v-for="star in parseInt(package.stars)">
									<svg width="106" height="106" viewBox="0 0 106 106" xmlns="http://www.w3.org/2000/svg"><path d="M52.089 85.55s-28.915 19.506-31.564 16.594c-2.649-2.913 6.028-34.23 6.028-34.23S.225 48.145 1.018 44.86c.792-3.284 35.289-7.881 35.289-7.881S47.958 5 52.089 5c4.13 0 15.782 31.978 15.782 31.978s34.503 4.597 36.21 7.881c1.708 3.284-26.456 23.056-26.456 23.056s9.594 32.234 6.028 34.229c-3.567 1.994-31.564-16.594-31.564-16.594z"/></svg>
								</span><span v-if="package.halfstar">
									<svg width="106" height="106" viewBox="0 0 106 106" xmlns="http://www.w3.org/2000/svg"><path d="M52.089 85.55s-28.915 19.506-31.564 16.594c-2.649-2.913 6.028-34.23 6.028-34.23S.225 48.145 1.018 44.86c.792-3.284 35.289-7.881 35.289-7.881S47.958 5 52.089 5c-.089 17 0 80.55 0 80.55z"/></svg>
								</span>
								<span class="hidden t:inline t:ml-1/4">Property</span>
							</div>
						</div>
						<div class="details" v-html="package.description"></div>
						<div class="details" v-html="'<p>Book by '+package.book_by+'</p>'"></div>
						<div class="footer">
							<a v-if="package.link" :href="package.link">
								<div class="pricetag relative mt-1/2">
									<span class="f8 absolute -top-1 font-read lowercase  text-light-grey">from</span>
									<span class="dollar ml-1/2">$</span>
									<span class="value" v-text="package.lowest_price"></span>
									<span v-if="package.pp" class="pp">pp</span>
								</div>
							</a>

							<a v-if="package.link" :href="package.link" class="action" v-text="package.link_text">
							</a>

						</div>
					</div>
				</div>
				<div v-if="group.packages.length==0" class="warning">
				No Results
				</div>
			</div>
		</div>
		<div class="package_more_info" v-html="link"></div>
		<slot></slot>
	</div>
	`,
	props:['intro'],
	data(){
		return {
			selectedDestination: Event.selectedDestination ? Event.selectedDestination : 'all',
			selectedLocale: Event.selectedLocale ? Event.selectedLocale : 'all',
			selectedFilter: Event.selectedFilter ? Event.selectedFilter : 7,
			selectedGroupSize: Event.selectedGroupSize ? Event.selectedGroupSize : 'all',
			sortBy: 'lowest_price',
			sortDirection: 'asc', // puts Bora Bora at top
			sortByDestination: true,
			localeGroup: false,
			allowLocaleSelection: true,
			packages: [],
			blacklist: Event.blacklist ? Event.blacklist : [],
			whitelist: Event.whitelist ? Event.whitelist : [],
			specialThemes: Config.packages.specialThemes,
			link: Event.micrositeLink ? Event.micrositeLink : '',
			dontAppearByDefault: Event.dontAppearByDefault ? Event.dontAppearByDefault : [],
		}
	},
	created() {
		this.packages = this.$children
	},
	mounted(){

		if (Event.selectedFilter) {
			this.selectedFilter = Event.selectedFilter
		} else {
			// let tabs = this.numberedTabs[0]
			// tabs = _.filter(tabs, function(tab) {
			// 	return tab.value > 0
			// })
			this.selectedFilter = this.numberedTabs[0]?this.numberedTabs[0].value:'x'

			if (!this.onlyAllowedSelected) {
				this.selectedFilter = 'all'
			}
		}

		if ( Event.noLocaleSelect ) {
			this.localeGroup = false
			this.allowLocaleSelection = false
		}

		this.selectedDestination = Event.selectedDestination

	},
	methods: {
		updateDestination(){
			this.selectedLocale = 'all'
			Event.$emit('selectedDestination', this.selectedDestination)
		},
		updateLocale(){
			this.selectedDestination = 'all'
			Event.$emit('selectedLocale', this.selectedLocale)
		},
		updateFilter(value){
			this.selectedLocale = 'all'
			this.selectedFilter = value
			// if (this.selectedFilter != 'all') {
			// 	this.localeGroup = false
			// } else {
			// 	this.localeGroup = true
			// }
			Event.$emit('selectedFilter', this.selectedFilter)
		},
		updateGroupSize(){
			Event.$emit('selectedGroupSize', this.selectedGroupSize)
		},
		bookOnlineLink() {
			if (Event.IBE == true){
				Event.$emit('loadIBE')
			} else {
				window.location.href = '/bookonline?destination='+this.filteredGroups[0].packages[0].destination_slug
			}
		},
		titlecase(str){
			str = str.replaceAll('-', ' ')
			str = str.toLowerCase()
			str = str.split(' ')
			for (var i = 0; i < str.length; i++) {
				str[i] = str[i].charAt(0).toUpperCase() + str[i].slice(1)
			}
			return str.join(' ')
		}
	},
	computed: {
		// groupSort(){
		// 	return _.includes(['family', 'group-holidays'], this.selectedFilter)
		// },
		onlyAllowedSelected(){
			return (this.destinationList.length == 1 && (_.includes(['fiji', 'norfolk-island', 'samoa', 'tahiti','the-cook-islands', 'vanuatu', 'lord-howe-island', 'new-zealand', 'the-solomon-islands', 'new-caledonia'], this.destinationList[0])))
		},
		blackAndWhiteListedPackages(){
			let packages
			if (this.whitelist.length){
				packages = _.filter(this.packages, s_package => {
					let themes = (JSON.parse(s_package.themes))
					themes = _.map(themes, 0)
					return _.intersection(themes, this.whitelist).length
				})
				return packages
			}

			packages = this.packages.filter(s_package => {
				let themes = (JSON.parse(s_package.themes))
				themes = _.map(themes, 0)
				return !_.intersection(themes, this.blacklist).length
			})
			return packages

		},
		firstIntro() {
			return _.find(JSON.parse(this.intro))
		},
		packageTabs() {
			let allTabs = _.concat(
				{value: 'all', label: 'All'},
				this.numberedTabs,
				this.themeTabs,
			)

			// allTabs = allTabs.filter(function(tab) {
			// 	return tab.value!='cheap-n-cheerful'
			// })

			allTabs = _.uniqBy(allTabs, 'value')

			return allTabs

		},
		numberedTabs() {

			let values = this.blackAndWhiteListedPackages
				.filter(s_package => {
					let themes = (JSON.parse(s_package.themes))
					themes = _.map(themes, 0)
					return isNumeric(s_package.nights) && _.isEmpty(_.intersection(themes, this.specialThemes))
				})
				.map( ( s_package ) => {
					return s_package.nights
				})
				.filter(s_package => {
					return s_package > 0
				})

			values = _.uniq(values)
			values = _.filter(values)

			values = values.map((value) => {
				return {value: parseInt(value), label: value+' night packages'}
			})

			values = _.sortBy(values, 'value')

			values = values.map((value) => {
				if (value.value <=5 && this.selectedDestination == 'norfolk-island'){
					return {value: 'short-stays', label: 'Short Stays'}
				}

				// Sometimes the amount of tabs are overwhelming and look stupid so we remove the numbered tabs
				if ( this.selectedDestination != 'norfolk-island' ){
					return {value: 'all', label: 'All'}
				}

				return value
			})

			values = _.uniq(values)

			return values
		},
		themeList() {
			let values = this.blackAndWhiteListedPackages.map( s_package =>(JSON.parse(s_package.themes)))
			values = _.flattenDepth(values,1)

			return values
		},
		themeValues() {
			return _.map(this.themeTabs, 'value')
		},
		themeTabs() {

			let values = this.themeList

			values = _.map(values, (value) => {
				if (value){
					return {value: value[0], label: value[1]}
				}
			})
			values = _.uniqBy(values, 'value')
			values = _.sortBy(values, 'value')
			values = _.filter(values)

			values = _.filter(values, value => {
				return !_.includes(this.blacklist, value.value)
			})

			return values
		},
		localeList() {
			let values = this.blackAndWhiteListedPackages
				.filter( s_package => {
					return this.selectedDestination == 'all' || this.selectedDestination == s_package.destination_slug
				})
				.map( s_package => {
					return s_package.locale
				})
			values = _.uniq(values)

			values = values.map( value => {
				let name = value
				let slug = value.toLowerCase().replace(/\W/g, '-')
				return {
					value: slug,
					name: name
				}
			})


			return values
		},
		destinationList() {
			let values = this.blackAndWhiteListedPackages.map( ( s_package ) => {
				return s_package.destination_slug
			})
			values = _.uniq(values)
			return values
		},
		groupSizeList(){
			let values = this.blackAndWhiteListedPackages
				.filter( s_package => {
					return _.includes(s_package.themes, this.selectedFilter)
				})
				.map( ( s_package ) => {
					return parseInt(s_package.group_size)
				})
				.filter(value => {
					return value > 0
				})
				.sort()

			values = _.uniq(values)
			return values
		},
		filteredDestinations() {
			let filteredPackages = this.blackAndWhiteListedPackages.map(function(s_package) {
				return {
					type: s_package.type,
					name: s_package.name,
					destination_slug: s_package.destination_slug,
					destination_order: parseInt(s_package.destination_order),
					locale: s_package.locale,
					locale_order: parseInt(s_package.locale_order),
					locale_in_destination: s_package.locale_in_destination,
					image_url: s_package.image_url,
					image_title: s_package.image_title,
					image_alt: s_package.image_alt,
					lowest_price: parseInt(s_package.lowest_price),
					nights: parseInt(s_package.nights),
					group_size: parseInt(s_package.group_size),
					pp: s_package.pp,
					book_by: s_package.book_by,
					link: s_package.link,
					link_text: s_package.link_text,
					description: s_package.description,
					rating: s_package.rating,
					stars: s_package.stars,
					halfstar: s_package.halfstar,
					themes: s_package.themes
				}
			})

			filteredPackages = filteredPackages.map((s_package) => {
				s_package['nights'] = parseInt(s_package['nights'])
				return s_package
			})

			var heading = ''
			if (this.selectedFilter == 'all'){
				heading = 'All Packages'
				filteredPackages = _.filter(filteredPackages, (s_package) => {
					// return true
					let themes = (JSON.parse(s_package.themes))
					themes = _.map(themes, 0)
					return _.isEmpty(_.intersection(themes, this.dontAppearByDefault))
				})
			}

			if (this.selectedFilter == 'short-stays'){
				heading = 'Short Stays'
				filteredPackages = _.filter(filteredPackages, (s_package) => {
					let themes = (JSON.parse(s_package.themes))
					themes = _.map(themes, 0)
					return isNumeric(s_package.nights) && s_package.nights <= 5 && s_package.nights > 0 && _.isEmpty(_.intersection(themes, this.specialThemes))
				})
			}

			if (isNumeric(this.selectedFilter)){
				heading = this.selectedFilter+' Night Packages'
				filteredPackages = _.filter(filteredPackages, s_package => {
					let themes = (JSON.parse(s_package.themes))
					themes = _.map(themes, 0)
					return (s_package.nights == this.selectedFilter) && _.isEmpty(_.intersection(themes, this.specialThemes))
				})
			}


			// filter by theme ---------------------------------------
			if (this.selectedFilter!='short-stays' && _.includes(this.themeValues, this.selectedFilter) ) {
				heading = this.selectedFilter
				let _this = this
				filteredPackages = _.filter(filteredPackages, function(s_package) {
					let themes = (JSON.parse(s_package.themes))
					themes = _.map(themes, 0)

					return _.includes(themes, _this.selectedFilter)
				})
			}

			//filter by Group Size
			if (this.groupSizeList.length > 1 && this.selectedGroupSize > 0 ) {
				filteredPackages = filteredPackages.filter( s_package => {
					return parseInt(s_package.group_size) == this.selectedGroupSize
				})
			}

			// Sortby ---------------------------------------

			filteredPackages = _.sortBy(filteredPackages, this.sortBy)

			if (this.sortDirection == 'desc'){
				filteredPackages = filteredPackages.reverse()
			}


			// SortBy Locale -------------
			let locales
			if (this.selectedLocale!='all') {
				locales = _.groupBy(filteredPackages, 'locale_in_destination')
			} else {
				locales = _.groupBy(filteredPackages, 'destination_slug')
			}
			let localesGroup = _.map(locales, function(s_package) {
				return {
					heading: s_package[0].locale+' - '+ heading,
					locale: s_package[0].locale,
					destination_slug: s_package[0].destination_slug,
					destination_order: s_package[0].destination_order,
					packages: s_package,
					order: parseInt(s_package[0].locale_order)
				}
			})
			localesGroup =_.sortBy(localesGroup, 'order')

			if (this.selectedLocale!='all'){
				localesGroup = localesGroup.filter((locale) => {
					return locale.locale.toLowerCase().replace(/\W/g, '-') == this.selectedLocale
				})
			}

			destinations = _.groupBy(localesGroup, 'destination_slug')

			destinations = _.filter(destinations, function(destination) {
				return destination[0].destination_slug.length
			})

			destinations = _.map(destinations, function(destination) {
				return {
					name: destination[0].destination_slug,
					destination_order: destination[0].destination_order,
					locales: destination
				}
			})
			destinations = _.sortBy(destinations, 'destination_order')

			if (this.selectedDestination!='all'){
				destinations = destinations.filter((destination) => {
					return destination.name == this.selectedDestination
				})
			}

			return destinations

		}
	}
})

Vue.component('package', {
	template: `<div><slot></slot></div>`,
	props: {
		type: {},
		name: { required: true },
		destination_slug: { required: true },
		destination_order: { },
		locale: { required: true },
		image_url: { required: true },
		image_title: { required: true },
		image_alt: { required: true },
		locale_order: {},
		lowest_price: {},
		locale_in_destination: {},
		nights: { required: true },
		group_size: {},
		pp: {},
		book_by: { required: true },
		link: { required: true },
		link_text: {},
		description: {},
		rating: {},
		stars: {},
		halfstar: {},
		themes: {},
	}
})


function isNumeric(n) {
	return !isNaN(parseFloat(n)) && isFinite(n)
}
